import { gql } from '@apollo/client';

export const GET_ADDRESS_LOCATION_TYPE_DICT_CONFIG = gql`
  query GetAddressLocationTypeDictConfig {
    getAddressLocationTypeDictConfig {
      primaryCode
      primaryNameZh
      secondaryCode
      secondaryNameZh
      sortOrder
    }
  }
`;

export interface AddressLocationTypeDictItem {
  primaryCode: string;
  primaryNameZh: string;
  secondaryCode: string;
  /** 二级分类名（仅中文，desktop-web 审核台展示用） */
  secondaryNameZh: string;
  sortOrder: number;
}

export interface GetAddressLocationTypeDictConfigResponse {
  getAddressLocationTypeDictConfig: AddressLocationTypeDictItem[];
}
